import { ccm19GetAcceptedEmbeddings } from "src/integrations/ccm19/api"
import { metaPixelId } from "src/integrations/meta/constants"
import {
  MetaAddPaymentInfoEvent,
  MetaAddToCartEvent,
  MetaAddToWishlistEvent,
  MetaBaseEvent,
  MetaInitiateCheckoutEvent,
  MetaPurchaseEvent,
  MetaSearchEvent,
  MetaViewContentEvent,
} from "src/integrations/meta/types"
import { MetaUserData } from "src/integrations/meta/userData"

// Unlike the Google Tag Manager, the Meta Pixel does not have a built-in way to
// handle events that are fired before the pixel is initialized.
let initialized = false
const eventsBeforeInit: any[] = []

function initFbq() {
  let fbq: any = window.fbq

  if (fbq) return

  // prettier-ignore
  // biome-ignore lint/complexity/useArrowFunction:
  // biome-ignore lint/style/noArguments:
  fbq = function () { if (fbq.callMethod) { fbq.callMethod.apply(fbq, arguments) } else { fbq.queue.push(arguments) } }

  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = "2.0"
  fbq.queue = []
  window.fbq = fbq

  // https://developers.facebook.com/ads/blog/post/2017/05/29/tagging-a-single-page-application-facebook-pixel/
  window.fbq.disablePushState = true
}

export function metaDebug(...args: unknown[]) {
  console.debug("♾️ meta:", ...args)
}

function metaPush(fnName: "init" | "track", ...args: unknown[]) {
  initFbq()

  if (fnName === "track" && !initialized) {
    metaDebug("not yet initialized, queueing event for later", fnName, ...args)
    eventsBeforeInit.push(args)
  } else {
    metaDebug(fnName, ...args)
    window.fbq(fnName, ...args)
  }
}

export function metaInit(userData: Partial<MetaUserData>) {
  // Init meta pixel with or without consent but not before consent was loaded.
  if (!ccm19GetAcceptedEmbeddings().length) {
    return
  }

  metaPush("init", metaPixelId, userData)
  initialized = true

  // Send all events that were pushed before the pixel was initialized.
  if (eventsBeforeInit.length) {
    for (const args of eventsBeforeInit) {
      metaPush("track", ...args)
    }
    eventsBeforeInit.length = 0
  }
}

export function metaTrack(name: string, { event_id, ...data }: MetaBaseEvent) {
  metaPush("track", name, data, { eventID: event_id })
}

export function metaTrackPageView(event: MetaBaseEvent) {
  metaTrack("PageView", event)
}

export function metaTrackSearch(event: MetaSearchEvent) {
  metaTrack("Search", event)
}

export function metaTrackViewContent(event: MetaViewContentEvent) {
  metaTrack("ViewContent", event)
}

export function metaTrackAddToWishlist(event: MetaAddToWishlistEvent) {
  metaTrack("AddToWishlist", event)
}

export function metaTrackAddToCart(event: MetaAddToCartEvent) {
  metaTrack("AddToCart", event)
}

export function metaTrackInitiateCheckout(event: MetaInitiateCheckoutEvent) {
  metaTrack("InitiateCheckout", event)
}

export function metaTrackAddPaymentInfo(event: MetaAddPaymentInfoEvent) {
  metaTrack("AddPaymentInfo", event)
}

export function metaTrackPurchase(event: MetaPurchaseEvent) {
  metaTrack("Purchase", event)
}
